var n=20,r=16,t=44,u=24,a=18;function e(t){return"small"===t?r:n}function l(n){return"small"===n?a:u}function o(n){return r=l(n),u=e(n),(r-u)*t/(2*r);var r,u}export{l as getProgressSize,o as getProgressThickness,e as getThumbSize};
